import { TranslateWithPluralize } from '@marketplace-web/i18n/i18n-data'
import { BumpOptionsModel } from '@marketplace-web/vas/vas-data'

type Props = {
  bumpOptions: BumpOptionsModel
  orderItemsCount: number
  hideMultiBumpDiscount: boolean
  translate: TranslateWithPluralize
}

export const generateBumpMotivationText = ({
  bumpOptions,
  orderItemsCount,
  hideMultiBumpDiscount,
  translate,
}: Props) => {
  const { freePushUpsCount, bumpableItemCount, discountPercentage, multiBumpDiscount } = bumpOptions

  if (discountPercentage > 0) {
    if (freePushUpsCount === 0) {
      return translate('motivation.discount', { count: discountPercentage })
    }
    if (freePushUpsCount > 0) {
      if (orderItemsCount > freePushUpsCount) {
        return translate(
          'motivation.free_bump_and_discount',
          { count: freePushUpsCount, discount: discountPercentage },
          { count: freePushUpsCount },
        )
      }
      if (orderItemsCount === freePushUpsCount) {
        return `${translate(
          'motivation.free_bump',
          { count: freePushUpsCount },
          { count: freePushUpsCount },
        )}, ${translate('motivation.remaining_discount', { count: discountPercentage })}`
      }
      if (orderItemsCount < freePushUpsCount) {
        const remainingFreeBumps = freePushUpsCount - orderItemsCount

        return `${translate(
          'motivation.free_bump',
          { count: orderItemsCount },
          { count: orderItemsCount },
        )}, 
            ${translate(
              'motivation.remaining_free_bump_and_discount',
              { count: remainingFreeBumps, discount: discountPercentage },
              { count: remainingFreeBumps },
            )}`
      }
    }
  }

  if (discountPercentage === 0) {
    const isEligibleForMultiBumpDiscount =
      bumpableItemCount - freePushUpsCount >= multiBumpDiscount.minPaidItemCount
    if (isEligibleForMultiBumpDiscount && !hideMultiBumpDiscount) {
      if (freePushUpsCount === 0) {
        return translate('motivation.multi_bump_discount')
      }
      if (orderItemsCount >= freePushUpsCount) {
        return `${translate(
          'motivation.free_bump',
          { count: freePushUpsCount },
          { count: freePushUpsCount },
        )} + ${translate('motivation.multi_bump_discount')}`
      }
      if (orderItemsCount < freePushUpsCount) {
        const remainingFreeBumps = freePushUpsCount - orderItemsCount

        return `${translate(
          'motivation.free_bump',
          { count: orderItemsCount },
          { count: orderItemsCount },
        )}, ${translate(
          'motivation.remaining_free_bump',
          { count: remainingFreeBumps },
          { count: remainingFreeBumps },
        )} + ${translate('motivation.multi_bump_discount')}`
      }
    }
    if (freePushUpsCount === 0) {
      return null
    }
    if (orderItemsCount >= freePushUpsCount) {
      return translate(
        'motivation.free_bump',
        { count: freePushUpsCount },
        { count: freePushUpsCount },
      )
    }
    if (orderItemsCount < freePushUpsCount) {
      const remainingFreeBumps = freePushUpsCount - orderItemsCount

      return `${translate(
        'motivation.free_bump',
        { count: orderItemsCount },
        { count: orderItemsCount },
      )}, ${translate(
        'motivation.remaining_free_bump',
        { count: remainingFreeBumps },
        { count: remainingFreeBumps },
      )}`
    }
  }

  return null
}
